import {
	ContentItemPayload,
	RatingContent,
} from "features/rating/content/types";
import api from "service/apiService";
import { ApiResponse } from "types";

export const getRatingContentsAPI = (): Promise<ApiResponse<RatingContent[]>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<RatingContent[]>>("/dashboard/rating-contents")
			.then(res => resolve(res.data))
			.catch(err => reject(err));
	});

export const getRatingContentAPI = (
	id: number,
): Promise<ApiResponse<RatingContent>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<RatingContent>>(`/dashboard/rating-contents/${id}`)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => reject(err));
	});

export const udpateRatingContentAPI = (
	items: ContentItemPayload[],
	id: number,
): Promise<ApiResponse<ContentItemPayload[]>> =>
	new Promise((resolve, reject) => {
		api
			.post<ApiResponse<ContentItemPayload[]>>(
				`/dashboard/rating-contents/${id}`,
				items,
			)
			.then(res => resolve(res.data))
			.catch(error => reject(error));
	});

export const udpateRatingContentStatusAPI = (
	status: boolean,
	id: number,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.patch<ApiResponse<ContentItemPayload[]>>(
				`/dashboard/rating-contents/${id}/status`,
				{ status },
			)
			.then(res => resolve(res.data))
			.catch(error => reject(error));
	});

export const getRatingsAPI = (
	query: any,
	language: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		const payload = JSON.parse(JSON.stringify(query));
		if (payload.contentTags?.length > 0) {
			payload.contentTags = payload.contentTags.join(",");
		} else {
			payload.contentTags = undefined;
		}
		api
			.get<ApiResponse<any>>("/dashboard/rating-reviews", {
				language,
				...payload,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});

export const getRatingContentTagsAPI = (
	query: any,
	language: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any>>("/dashboard/rating-contents/tags", {
				language,
				...query,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});
export const getMerchantDetailRatings = (
	id: string,
	query: any,
	language: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any>>(`/dashboard/merchants/${id}/ratings`, {
				language,
				...query,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});

export const getBookingReviewsAPI = (
	id: string,
	language: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any>>(`/dashboard/bookings/${id}/reviews`, {
				language,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});

export const getPurchaseReviewsAPI = (
	id: string,
	language: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any>>(`/dashboard/purchase-orders/${id}/reviews`, {
				language,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});

export const getMerchantAverageRatingStarAPI = (
	id: string,
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any>>(`/dashboard/merchants/${id}/ratings/average`)
			.then(res => {
				resolve(res.data);
			})
			.catch(error => reject(error));
	});
